



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component
export default class CountTo extends Vue {
  @Prop() count!: number;
  @Prop() size!: number;
  public orderNum: any[] = [];

  get fontSize() {
    return this.size < 22 ? 12 : this.size;
  }

  @Watch('count', { immediate: true })
  countChange(val) {
    const countString = val.toString();
    this.orderNum = new Array(countString.length).fill('0');
    // this.$nextTick(() => {
    //   this.toOrderNum(val);
    //   this.setNumberTransform();
    // });
  }
  // 设置文字滚动
  setNumberTransform() {
    const numberItems: any = this.$refs.numberItem; // 拿到数字的ref，计算元素数量
    const numberArr = this.orderNum.filter((item) => !isNaN(item));
    // 结合CSS 对数字字符进行滚动,显示订单数量
    if (numberItems) {
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`;
      }
    }
  }
  // 处理总订单数字
  toOrderNum(num) {
    num = num.toString();
    this.orderNum = num.split('');
  }
  // 开始滚动
  async startNumberTransform() {
    const countString = this.count.toString();
    this.orderNum = new Array(countString.length).fill('0');
    this.$nextTick(() => {
      this.toOrderNum(this.count);
      this.setNumberTransform();
    });
  }
  // 重置 归位
  resetPostion() {
    const numberItems: any = this.$refs.numberItem; // 拿到数字的ref，计算元素数量
    // 结合CSS 对数字字符进行滚动,显示订单数量
    if (numberItems) {
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index];
        elem.style.transform = 'translate(-50%, 0)';
      }
    }
  }
}
